import React, { useEffect, useState } from 'react';
import { Typography, Breadcrumb, Card, Form, Input, Select, Switch, Button, Space, message } from 'antd';
import axios from 'axios';

const { Title, Paragraph } = Typography;
const { Option } = Select;

const PaymentGateways = () => {
  const [saving, setSaving] = useState(false);
  const [form] = Form.useForm();

  useEffect(() => {
    const load = async () => {
      try {
        const { data } = await axios.get('/api/payment-gateways');
        if (data) {
          form.setFieldsValue({
            provider: data.provider || 'stripe',
            stripe_public_key: data.stripe_public_key || '',
            stripe_secret_key: data.stripe_secret_key || '',
            paypal_client_id: data.paypal_client_id || '',
            paypal_secret: data.paypal_secret || '',
            live_mode: !!data.live_mode,
          });
        } else {
          form.setFieldsValue({ provider: 'stripe', live_mode: false });
        }
      } catch (e) {
        message.error(e.response?.data?.error || 'Failed to load payment gateway settings');
      }
    };
    load();
  }, [form]);

  const onSubmit = async () => {
    try {
      await form.validateFields();
      setSaving(true);
      const values = form.getFieldsValue();
      const headers = {};
      const token = sessionStorage.getItem('token');
      if (token) headers.Authorization = `Bearer ${token}`;
      await axios.put('/api/payment-gateways', values, { headers });
      message.success('Payment gateway settings saved');
    } catch (e) {
      if (e?.errorFields) return;
      message.error(e.response?.data?.error || e.message || 'Failed to save settings');
    } finally {
      setSaving(false);
    }
  };

  return (
    <div style={{ padding: 24 }}>
      <Breadcrumb items={[
        { title: 'Admin' },
        { title: 'Billing' },
        { title: 'Payment Gateways' },
      ]} />

      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: 12, marginBottom: 16 }}>
        <Title level={3} style={{ margin: 0 }}>Payment Gateway Settings</Title>
        <Space>
          <Button type="primary" onClick={onSubmit} loading={saving}>Save Settings</Button>
        </Space>
      </div>

      <Card>
        <Paragraph type="secondary" style={{ marginBottom: 12 }}>
          Configure your payment provider. Replace placeholders with your backend settings endpoints.
        </Paragraph>
        <Form form={form} layout="vertical">
          <Form.Item label="Provider" name="provider" rules={[{ required: true }]}> 
            <Select>
              <Option value="stripe">Stripe</Option>
              <Option value="paypal">PayPal</Option>
            </Select>
          </Form.Item>

          <Form.Item noStyle shouldUpdate={(prev, curr) => prev.provider !== curr.provider}>
            {({ getFieldValue }) => getFieldValue('provider') === 'stripe' ? (
              <>
                <Form.Item label="Stripe Public Key" name="stripe_public_key" rules={[{ required: true }]}>
                  <Input placeholder="pk_live_... or pk_test_..." />
                </Form.Item>
                <Form.Item label="Stripe Secret Key" name="stripe_secret_key" rules={[{ required: true }]}>
                  <Input.Password placeholder="sk_live_... or sk_test_..." />
                </Form.Item>
              </>
            ) : (
              <>
                <Form.Item label="PayPal Client ID" name="paypal_client_id" rules={[{ required: true }]}>
                  <Input />
                </Form.Item>
                <Form.Item label="PayPal Secret" name="paypal_secret" rules={[{ required: true }]}>
                  <Input.Password />
                </Form.Item>
              </>
            )}
          </Form.Item>

          <Form.Item label="Live Mode" name="live_mode" valuePropName="checked">
            <Switch />
          </Form.Item>
        </Form>
      </Card>
    </div>
  );
};

export default PaymentGateways;
